// src/services/api.js
import axios from "axios";
import { toast } from "react-toastify";

export const currentApiEndpoint = process.env.REACT_APP_API_URL || 'https://api.readablenglish.com/api/v1';
//export const currentApiEndpoint = process.env.REACT_APP_API_URL || "http://localhost:8080/api/v1";
//let currentApiEndpoint = process.env.REACT_APP_API_URL || 'https://dev-api.readablenglish.com/api/v1';
//export const currentApiEndpoint = process.env.REACT_APP_API_URL || 'https://prod.readablenglish.com/api/v1';

//let currentApiEndpoint = process.env.REACT_APP_API_URL || currentApiEndpointBase;

export const api = axios.create({
  baseURL: `${currentApiEndpoint}`,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const updateApiEndpoint = (newEndpoint) => {
  // currentApiEndpoint = newEndpoint;
  // api.defaults.baseURL = `${currentApiEndpoint}/api/v1`;
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = token.startsWith("ApiKey ")
        ? token
        : `ApiKey ${token}`;
    } else {
      console.warn("No auth token for request:", config.url);
      if (!config.url.includes("login") && !config.url.includes("public")) {
        toast.warning(
          "Authentication token missing. You may need to log in again.",
        );
      }
    }
    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Enhanced error logging
    console.error("API Error:", {
      message: error.message,
      config: error.config
        ? {
            url: error.config.url,
            method: error.config.method,
            headers: error.config.headers,
          }
        : "No config",
      response: error.response
        ? {
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data,
          }
        : "No response",
    });

    // Handle specific error cases
    if (error.response) {
      // Server responded with a status code outside of 2xx

      const message = error?.response?.data?.error?.message;

      if (message) {
        toast.error(message);
      } else {
        switch (error.response.status) {
          case 401:
            // Clear token and redirect to login
            localStorage.removeItem("authToken");
            toast.error("Your session has expired. Please log in again.");
            window.location.href = "/login";
            return Promise.reject(new Error("Session expired"));

          case 403:
            toast.error("You do not have permission to access this resource.");
            break;

          case 404:
            toast.error("The requested resource was not found.");
            break;

          case 409:
            toast.error("Action could not be completed due to a conflict.");
            break;

          case 500:
            toast.error("Server error. Please try again later.");
            break;

          default:
            const message =
              error.response.data?.message ||
              "An error occurred with status: " + error.response.status;
            toast.error(message);
        }
      }
    } else if (error.request) {
      // Request was made but no response received
      toast.error("No response from server. Please check your connection.");
    } else {
      // Error setting up the request
      const message = error.message || "An unexpected error occurred";
      if (!message.includes("timeout")) {
        toast.error(message);
      }
    }

    return Promise.reject(error);
  },
);

export const extractResponseData = (response) => {
  if (response && response.data) {
    if (response.data.w !== undefined) {
      return response.data.w;
    } else if (response.data.data !== undefined) {
      return response.data.data;
    } else {
      return response.data;
    }
  }
  return null;
};

export const firebaseConfig = {
  //   apiKey: "AIzaSyD1HsNRbCv1MfxY-IBcDeoKxy4DZjPUHZg",
  //   authDomain: "readable-english-local.firebaseapp.com",
  //   projectId: "readable-english-local",
  //   storageBucket: "readable-english-local.firebasestorage.app",
  //   messagingSenderId: "101985928073",
  //   appId: "1:101985928073:web:ad5603e8cb94da7f795758",
  //   measurementId: "G-7XN2VLCKKZ"

  //   apiKey: "AIzaSyB7g7jup02gUAkJ9Sj9A98qTLtx_tf2m74",
  //   authDomain: "readable-english-staging.firebaseapp.com",
  //   projectId: "readable-english-staging",
  //   storageBucket: "readable-english-staging.firebasestorage.app",
  //   messagingSenderId: "737781955989",
  //   appId: "1:737781955989:web:8ac4ac0c0ce50a689b0a9c",
  //   measurementId: "G-RJS6B9Y41R"

  //  apiKey: "AIzaSyATtJTZsk0TPfrI6HjIJzjYsXoISuZRl6U",
  // authDomain: "readable-english-dev.firebaseapp.com",
  // projectId: "readable-english-dev",
  // storageBucket: "readable-english-dev.firebasestorage.app",
  // messagingSenderId: "966884761937",
  // appId: "1:966884761937:web:15a66f2a7484494eb23370",
  // measurementId: "G-SV4ERQ7GRS"

  apiKey: "AIzaSyDSVAd6RXIpqtqnxZCSl78a4L4Yg5H-yO8",
  authDomain: "readable-english-prod.firebaseapp.com",
  projectId: "readable-english-prod",
  storageBucket: "readable-english-prod.firebasestorage.app",
  messagingSenderId: "71898087806",
  appId: "1:71898087806:web:ad15ad4ca7a0abd68ff32f",
  measurementId: "G-RTSLYLL19B",
};
